import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

export const TermsSectionWrapper = styled.div<{
    isNicole: boolean;
}>(
    ({ isNicole }) => css`
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: 48px;

        ${maxWidth('md')} {
            padding-top: 24px;
        }

        ${!isNicole &&
        css`
            align-self: flex-end;
        `}
    `,
);

export const NicoleImage = styled.img`
    max-width: 440px;
    width: 80%;
`;

export const TermsInnerWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const TermsButton = styled(Button)`
    margin: 24px 0 20px;
    max-width: 360px;
    width: 100%;

    ${maxWidth('md')} {
        max-width: unset;
    }
`;

export const TermsText = styled(Typography.TextBody_12_18)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
    `,
);

export const ListItem = styled(TermsText)(
    ({ theme: { fontWeight, palette } }) => css`
        position: relative;

        &::before {
            color: ${palette.text.assistive};
            content: '•';
            font-weight: ${fontWeight.bold};
            left: -12px;
            position: absolute;
            width: 4px;
        }
    `,
);

export const TermsList = styled.ul`
    list-style: none;
    margin: 0;
    max-width: 486px;
    padding-left: 20px;

    ${maxWidth('md')} {
        max-width: unset;
    }
`;
